
import React, {useState, useEffect} from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";

import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Divider from "@material-ui/core/Divider";
import CreateResaurants from "./createRes";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import firebase from "firebase/compat/app";
import { FStorage, firebase_Db } from "../../config/firebaseConfig";




const DBName = "Restaurants";
function ListResaurants({restData, index}){
    const { data, id } = restData;
    const [openEdit, setEdit] = useState(false);
  
    return (
      <>
        <List key={id}>
          <ListItem>
          <ListItemAvatar>
            <Avatar
              alt="Remy Sharp"
              src={data.imgUrl}
              sx={{ width: 100, height: 100 }}
              className="productlist_avatar"
            />
          </ListItemAvatar>
            <ListItemText
              primary={`Restaurant Name: ${data.name}`}
              
            />
            <ListItemSecondaryAction>
              <IconButton edge="end" aria-label="delete">
                <DeleteIcon
                  color="error"
                  fontSize="large"
                  onClick={async (_) => {
                    await firebase_Db.collection(DBName).doc(id).delete();
                    alert("Restaurant Deleted");
                  }}
                />
              </IconButton>
              <IconButton
                edge="end"
                aria-label="edit"
                onClick={() => {
                  setEdit(!openEdit);
                }}
              >
                <EditIcon color="primary" fontSize="large" />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          {openEdit && (
            <CreateResaurants
              btnName="Edit"
              titleName="Edit Message"
              restaurantData={restData}
              submitType="Edit"
            />
          )}
        </List>
        <Divider dark />
      </>
    );
}

export default ListResaurants;